import PrerollPlayer from "../components/preroll/PrerollPlayer";
import * as React from 'react'

export interface VideoContextType {
    muted: boolean
    activeActivePlayer: PrerollPlayer
    updateContext: (newContext: VideoContextType) => void
}

export const videoContextDefaultValue: VideoContextType = {
    muted: true,
    activeActivePlayer: null,
    updateContext: null
}

export const VideoContext = React.createContext(videoContextDefaultValue)